
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bulkoverview",
      function () {
        return require("private-next-pages/bulkoverview/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bulkoverview"])
      });
    }
  